import { render, staticRenderFns } from "./P_pantreats.vue?vue&type=template&id=473888f9&scoped=true&"
import script from "./P_pantreats.vue?vue&type=script&lang=js&"
export * from "./P_pantreats.vue?vue&type=script&lang=js&"
import style0 from "./P_pantreats.vue?vue&type=style&index=0&id=473888f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473888f9",
  null
  
)

export default component.exports